import {
    FETCH_AI_MAILER_THREADS,
    CLEAN_AI_MAILER_THREADS,
    DELETE_AI_MAILER_THREAD,
    DELETE_AI_MAILER_THREADS,
    IGNORE_AI_MAILER_THREAD,
    UNIGNORE_AI_MAILER_THREAD,
} from '../actions/types';
import _ from "lodash";
import {toNumber} from "../functions";

const AI_MAILER_THREADS_DEFAULT_STATE = {};

const AiMailerThreadsReducer = (state = AI_MAILER_THREADS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_AI_MAILER_THREADS:
            return payload;

        case IGNORE_AI_MAILER_THREAD:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    item = { ...item, ignored: 1 };
                }

                return item;
            }) };

        case UNIGNORE_AI_MAILER_THREAD:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload)) {
                    item = { ...item, ignored: 0 };
                }

                return item;
            }) };

        case CLEAN_AI_MAILER_THREADS:
        case DELETE_AI_MAILER_THREAD:
        case DELETE_AI_MAILER_THREADS:
            return AI_MAILER_THREADS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default AiMailerThreadsReducer;
